/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

class SyncOrders {
	constructor() {
		this.btn = document.getElementById('sync-orders');
		this.btn2 = document.getElementById('sync-products');
		this.companiesBtn = document.getElementById('sync-companies');
		/** Import orders form the csv */
		this.importOrdersBtn = document.getElementById('import-orders');
		this.btnStop = document.getElementById('sync-stop');
		this.init();
		this.stopImport = false;
		this.page = 0;
		this.importTries = 0;
		this.syncSingle = false;
	}

	init() {
		if (null !== this.btn) {
			this.btn.onclick = () => {
				$('.sync-holder').prepend('Import Started<br>');
				this.stopImport = false;
				const syncPage = $('.sync-page').val();
				this.syncSingle = $('.sync-single:checked').val() ? true : false;
				if (parseInt(syncPage) > 0) {
					this.page = syncPage;
				} else {
					this.page = 1;
				}
				this.callData();
			};
		}
		/**
		 * delete this after product update delete
		 */
		if (null !== this.btn2) {
			this.btn2.onclick = () => {
				$('.sync-holder').prepend('Update Started<br>');
				this.stopImport = false;
				const syncPage = $('.sync-page').val();
				this.syncSingle = $('.sync-single:checked').val() ? true : false;
				if (parseInt(syncPage) > 0) {
					this.page = syncPage;
				} else {
					this.page = 1;
				}
				this.productData();
			};
		}
		/**
		 * delete this after product update delete
		 */
		if (null !== this.companiesBtn) {
			this.companiesBtn.onclick = () => {
				$('.sync-holder').prepend('Update Started<br>');
				this.stopImport = false;
				const syncPage = $('.sync-page').val();
				this.syncSingle = $('.sync-single:checked').val() ? true : false;
				if (parseInt(syncPage) > 0) {
					this.page = syncPage;
				} else {
					this.page = 1;
				}
				this.companiesData();
			};
		}
		/**
		 * delete this after order import
		 */
		if (null !== this.importOrdersBtn) {
			this.importOrdersBtn.onclick = () => {
				$('.sync-holder').prepend('Orders Import Started.<br>');
				this.stopImport = false;
				const syncPage = $('.sync-page').val();
				this.syncSingle = $('#import-single:checked').val() ? true : false;
				if (parseInt(syncPage) > 0) {
					this.page = syncPage;
				} else {
					this.page = 0;
				}
				this.ordersData();
			};
		}
		if (null !== this.btnStop) {
			this.btnStop.onclick = () => {
				$('.sync-holder').prepend('Import Stopping<br>');
				this.stopImport = true;
			};
		}
	}

	/**
	 * after product update delete productData()
	 * @returns {string}
	 */
	companiesData() {
		const data = {
			action: 'syncCompanies',
			page: this.page
		};

		if (this.stopImport === true) {
			$('.sync-holder').prepend('Import Stopped<br>');
			return 'import Stopped';
		}

		$.ajax({
			url: kadraGlobal.ajax,
			data: data,
			type: 'POST',
			dataType: 'json',
			success: (res) => {
				$('.sync-holder').prepend(res.data.log + '<br>');
				$('.sync-holder').prepend(this.page + '<br>');
				if (this.syncSingle === false) {
					if (res.data.status === 1) {
						this.page++;
					} else if (res.data.status === 2 && this.importTries < 3) {
						this.importTries++;
					} else {
						this.page++;
						this.importTries = 0;
					}
					setTimeout(() => {
						this.companiesData();
					}, 2000);
				}
			}
		});
	}

	/**
	 * after product update delete productData()
	 * @returns {string}
	 */
	ordersData() {
		const data = {
			action: 'importOrders',
			page: this.page
		};
		if (this.stopImport === true) {
			$('.sync-holder').prepend('Import Stopped.<br>');
			return 'import Stopped';
		}

		$.ajax({
			url: kadraGlobal.ajax,
			data: data,
			type: 'POST',
			dataType: 'json',
			success: (res) => {
				$('.sync-holder').prepend(res.data.log + '<br>');
				if (this.syncSingle === false) {
					if (res.data.status === 1) {
						this.page++;
					} else if (res.data.status === 2 && this.importTries < 3) {
						this.importTries++;
					} else {
						this.page++;
						this.importTries = 0;
					}
					if (res.data.log === '') {
						this.stopImport = true;
					}
					this.ordersData();

				}
			}
		});
	}

	/**
	 * after product update delete productData()
	 * @returns {string}
	 */
	productData() {
		const data = {
			action: 'syncProducts',
			page: this.page
		};

		if (this.stopImport === true) {
			$('.sync-holder').prepend('Import Stopped<br>');
			return 'import Stoped';
		}

		$.ajax({
			url: kadraGlobal.ajax,
			data: data,
			type: 'POST',
			dataType: 'json',
			success: (res) => {
				$('.sync-holder').prepend(res.data.log + '<br>');
				$('.sync-holder').prepend(this.page + '<br>');
				if (this.syncSingle === false) {
					if (res.data.status === 1) {
						this.page++;
					} else if (res.data.status === 2 && this.importTries < 3) {
						this.importTries++;
					} else {
						this.page++;
						this.importTries = 0;
					}
					setTimeout(() => {
						this.productData();
					}, 2000);
				}
			}
		});
	}

	callData() {
		const data = {
			action: 'syncOrders',
			page: this.page
		};

		if (this.stopImport === true) {
			$('.sync-holder').prepend('Import Stopped<br>');
			return 'import Stoped';
		}

		$.ajax({
			url: kadraGlobal.ajax,
			data: data,
			type: 'POST',
			dataType: 'json',
			success: (res) => {
				$('.sync-holder').prepend(res.data.log + '<br>');
				if (this.syncSingle === false) {
					if (res.data.status === 1) {
						this.page++;
					} else if (res.data.status === 2 && this.importTries < 3) {
						this.importTries++;
					} else {
						this.page++;
						this.importTries = 0;
					}
					setTimeout(() => {
						this.callData();
					}, 2000);
				}
			}
		});

	}
}

export default SyncOrders;
